import Vue from 'vue'
import Router from 'vue-router'

// States
import States from '@/components/Pages/States/States'
import StatesIndex from '@/components/Pages/States/StatesIndex'

// Index
import Index from '@/components/Pages/Index/Index'
import Index2 from '@/components/Pages/Index/Index2'
import Index3 from '@/components/Pages/Index/Index3'
// Documents
import Documents from '@/components/Pages/Documents/Documents'
import DocumentsIndex from '@/components/Pages/Documents/DocumentsIndex'
// Document
import Document from '@/components/Pages/Document/Document'
import DocumentIndex from '@/components/Pages/Document/DocumentIndex'
// Mypage
import Mypage from '@/components/Pages/Mypage/Mypage'
// Versions
import Versions from '@/components/Pages/Versions/Versions'
import VersionsIndex from '@/components/Pages/Versions/VersionsIndex'
// Print
import Print from '@/components/Pages/Print/Print'
import PrintAp from '@/components/Pages/Print/PrintAp'
// Users
import Users from '@/components/Pages/Users/Users'
import UsersIndex from '@/components/Pages/Users/UsersIndex'
import UsersAdd from '@/components/Pages/Users/UsersAdd'
// User
import User from '@/components/Pages/User/User'
import UserIndex from '@/components/Pages/User/UserIndex'
import UserImg from '@/components/Pages/User/UserImg'
// Advisors
import Advisors from '@/components/Pages/Advisors/Advisors'
import AdvisorsIndex from '@/components/Pages/Advisors/AdvisorsIndex'
import AdvisorsAdd from '@/components/Pages/Advisors/AdvisorsAdd'
// Advisor
import Advisor from '@/components/Pages/Advisor/Advisor'
import AdvisorIndex from '@/components/Pages/Advisor/AdvisorIndex'
// Channels
import Channels from '@/components/Pages/Channels/Channels'
import ChannelsIndex from '@/components/Pages/Channels/ChannelsIndex'
// Channel
import Channel from '@/components/Pages/Channel/Channel'
import ChannelIndex from '@/components/Pages/Channel/ChannelIndex'
// Office_channels
import Office_channels from '@/components/Pages/Office_channels/Office_channels'
import Office_channelsIndex from '@/components/Pages/Office_channels/Office_channelsIndex'
// Office_channel
import Office_channel from '@/components/Pages/Office_channel/Office_channel'
import Office_channelIndex from '@/components/Pages/Office_channel/Office_channelIndex'
// Appointment_channels
import Appointment_channels from '@/components/Pages/Appointment_channels/Appointment_channels'
import Appointment_channelsIndex from '@/components/Pages/Appointment_channels/Appointment_channelsIndex'
// Appointment_channel
import Appointment_channel from '@/components/Pages/Appointment_channel/Appointment_channel'
import Appointment_channelIndex from '@/components/Pages/Appointment_channel/Appointment_channelIndex'
// Tutor_channels
import Tutor_channels from '@/components/Pages/Tutor_channels/Tutor_channels'
import Tutor_channelsIndex from '@/components/Pages/Tutor_channels/Tutor_channelsIndex'
// Tutor_channel
import Tutor_channel from '@/components/Pages/Tutor_channel/Tutor_channel'
import Tutor_channelIndex from '@/components/Pages/Tutor_channel/Tutor_channelIndex'
// Appointments
import Appointments from '@/components/Pages/Appointments/Appointments'
import AppointmentsIndex from '@/components/Pages/Appointments/AppointmentsIndex'
import ConfirmsIndex from '@/components/Pages/Appointments/ConfirmsIndex'
import AppointmentsAdd from '@/components/Pages/Appointments/AppointmentsAdd'
import AppointmentsModal from '@/components/Pages/Appointments/AppointmentsModal'
import AppointmentsCalendar from '@/components/Pages/Appointments/AppointmentsCalendar'
// Appointment
import Appointment from '@/components/Pages/Appointment/Appointment'
import AppointmentIndex from '@/components/Pages/Appointment/AppointmentIndex'
import AppointmentMap from '@/components/Pages/Appointment/AppointmentMap'
import AppointmentHistory from '@/components/Pages/Appointment/AppointmentHistory'
// Appointments2
import Appointments2 from '@/components/Pages/Appointments/Appointments2'
import AppointmentsIndex2 from '@/components/Pages/Appointments/AppointmentsIndex2'
// Appointment2
import Appointment2 from '@/components/Pages/Appointment/Appointment2'
import AppointmentIndex2 from '@/components/Pages/Appointment/AppointmentIndex2'
import AppointmentMap2 from '@/components/Pages/Appointment/AppointmentMap2'
// Families
import Families from '@/components/Pages/Families/Families'
import FamiliesIndex from '@/components/Pages/Families/FamiliesIndex'
import FamiliesAdd from '@/components/Pages/Families/FamiliesAdd'
// Family
import Family from '@/components/Pages/Family/Family'
import FamilyIndex from '@/components/Pages/Family/FamilyIndex'
import FamilyMap from '@/components/Pages/Family/FamilyMap'
import FamilyHistory from '@/components/Pages/Family/FamilyHistory'
import FamilyAppointmentView from '@/components/Pages/Family/FamilyAppointmentView'
import FamilyfileView from '@/components/Pages/Family/FamilyfileView'
import FamilyAgreements from '@/components/Pages/Family/FamilyAgreements'
// Students
import Students from '@/components/Pages/Students/Students'
import StudentsIndex from '@/components/Pages/Students/StudentsIndex'
import StudentsAdd from '@/components/Pages/Students/StudentsAdd'
import StudentsIndexInheritance from '@/components/Pages/Students/StudentsIndexInheritance'
// Student
import Student from '@/components/Pages/Student/Student'
import StudentIndex from '@/components/Pages/Student/StudentIndex'
import StudentMap from '@/components/Pages/Student/StudentMap'
import StudentHistory from '@/components/Pages/Student/StudentHistory'
import StudentfileView from '@/components/Pages/Student/StudentfileView'
import StudentReports from '@/components/Pages/Student/StudentReports'
import StudentAgreements from '@/components/Pages/Student/StudentAgreements'
// Tutors
import Tutors from '@/components/Pages/Tutors/Tutors'
import TutorsIndex from '@/components/Pages/Tutors/TutorsIndex'
import TutorsAdd from '@/components/Pages/Tutors/TutorsAdd'
// Tutor
import Tutor from '@/components/Pages/Tutor/Tutor'
import TutorIndex from '@/components/Pages/Tutor/TutorIndex'
import TutorMedium from '@/components/Pages/Tutor/TutorMedium'
import TutorMedium2 from '@/components/Pages/Tutor/TutorMedium2'
import TutorMap from '@/components/Pages/Tutor/TutorMap'
import TutorHistory from '@/components/Pages/Tutor/TutorHistory'
import TutorHistory2 from '@/components/Pages/Tutor/TutorHistory2'
import TutorfileView from '@/components/Pages/Tutor/TutorfileView'
import TutorfileView2 from '@/components/Pages/Tutor/TutorfileView2'
import TutorReports from '@/components/Pages/Tutor/TutorReports'
import TutorAgreements from '@/components/Pages/Tutor/TutorAgreements'
import TutorImg from '@/components/Pages/Tutor/TutorImg'
// Tutors2
import Tutors2 from '@/components/Pages/Tutors/Tutors2'
import TutorsIndex2 from '@/components/Pages/Tutors/TutorsIndex2'
// Tutor2
import Tutor2 from '@/components/Pages/Tutor/Tutor2'
import TutorIndex2 from '@/components/Pages/Tutor/TutorIndex2'
import TutorStudent2 from '@/components/Pages/Tutor/TutorStudent2'
import TutorMap2 from '@/components/Pages/Tutor/TutorMap2'
// Appointmentsupports
import Appointmentsupports from '@/components/Pages/Appointmentsupports/Appointmentsupports'
import AppointmentsupportsIndex from '@/components/Pages/Appointmentsupports/AppointmentsupportsIndex'
// Familysupports
import Familysupports from '@/components/Pages/Familysupports/Familysupports'
import FamilysupportsIndex from '@/components/Pages/Familysupports/FamilysupportsIndex'
// // Familysupport
// import Familysupport from '@/components/Pages/Familysupport/Familysupport'
// import FamilysupportIndex from '@/components/Pages/Familysupport/FamilysupportIndex'

// Tutorsupports
import Tutorsupports from '@/components/Pages/Tutorsupports/Tutorsupports'
import TutorsupportsIndex from '@/components/Pages/Tutorsupports/TutorsupportsIndex'
// // Tutorsupport
// import Tutorsupport from '@/components/Pages/Tutorsupport/Tutorsupport'
// import TutorsupportIndex from '@/components/Pages/Tutorsupport/TutorsupportIndex'

// Familyfiles
import Familyfiles from '@/components/Pages/Familyfiles/Familyfiles'
import FamilyfilesIndex from '@/components/Pages/Familyfiles/FamilyfilesIndex'
// Familyfile
import Familyfile from '@/components/Pages/Familyfile/Familyfile'
import FamilyfileIndex from '@/components/Pages/Familyfile/FamilyfileIndex'
// Studentfiles
import Studentfiles from '@/components/Pages/Studentfiles/Studentfiles'
import StudentfilesIndex from '@/components/Pages/Studentfiles/StudentfilesIndex'
// Studentfile
import Studentfile from '@/components/Pages/Studentfile/Studentfile'
import StudentfileIndex from '@/components/Pages/Studentfile/StudentfileIndex'
// Tutorfiles
import Tutorfiles from '@/components/Pages/Tutorfiles/Tutorfiles'
import TutorfilesIndex from '@/components/Pages/Tutorfiles/TutorfilesIndex'
// Tutorfile
import Tutorfile from '@/components/Pages/Tutorfile/Tutorfile'
import TutorfileIndex from '@/components/Pages/Tutorfile/TutorfileIndex'
// Reports
import Reports from '@/components/Pages/Reports/Reports'
import ReportsIndex from '@/components/Pages/Reports/ReportsIndex'
// Report
import Report from '@/components/Pages/Report/Report'
import ReportIndex from '@/components/Pages/Report/ReportIndex'
// Student_tutors
import Student_tutors from '@/components/Pages/Student_tutors/Student_tutors'
import Student_tutorsIndex from '@/components/Pages/Student_tutors/Student_tutorsIndex'
// Student_tutor
import Student_tutor from '@/components/Pages/Student_tutor/Student_tutor'
import Student_tutorIndex from '@/components/Pages/Student_tutor/Student_tutorIndex'
// Tags
import Tags from '@/components/Pages/Tags/Tags'
import TagsIndex from '@/components/Pages/Tags/TagsIndex'
// Tag
import Tag from '@/components/Pages/Tag/Tag'
import TagIndex from '@/components/Pages/Tag/TagIndex'
// Conditions
import Conditions from '@/components/Pages/Conditions/Conditions'
import ConditionsIndex from '@/components/Pages/Conditions/ConditionsIndex'
// Condition
import Condition from '@/components/Pages/Condition/Condition'
import ConditionIndex from '@/components/Pages/Condition/ConditionIndex'
// Student_conditions
import Student_conditions from '@/components/Pages/Student_conditions/Student_conditions'
import Student_conditionsIndex from '@/components/Pages/Student_conditions/Student_conditionsIndex'
// Student_condition
import Student_condition from '@/components/Pages/Student_condition/Student_condition'
import Student_conditionIndex from '@/components/Pages/Student_condition/Student_conditionIndex'
// Tutor_conditions
import Tutor_conditions from '@/components/Pages/Tutor_conditions/Tutor_conditions'
import Tutor_conditionsIndex from '@/components/Pages/Tutor_conditions/Tutor_conditionsIndex'
// Tutor_condition
import Tutor_condition from '@/components/Pages/Tutor_condition/Tutor_condition'
import Tutor_conditionIndex from '@/components/Pages/Tutor_condition/Tutor_conditionIndex'
// Todos
import Todos from '@/components/Pages/Todos/Todos'
import TodosIndex from '@/components/Pages/Todos/TodosIndex'
// Todo
import Todo from '@/components/Pages/Todo/Todo'
import TodoIndex from '@/components/Pages/Todo/TodoIndex'
// Agreements
import Agreements from '@/components/Pages/Agreements/Agreements'
import AgreementsIndex from '@/components/Pages/Agreements/AgreementsIndex'
import AgreementsAdd from '@/components/Pages/Agreements/AgreementsAdd'
// Agreement
import Agreement from '@/components/Pages/Agreement/Agreement'
import AgreementIndex from '@/components/Pages/Agreement/AgreementIndex'
import AgreementHistory from '@/components/Pages/Agreement/AgreementHistory'
import AgreementDiff from '@/components/Pages/Agreement/AgreementDiff'
import AgreementPdf from '@/components/Pages/Agreement/AgreementPdf'
// Aggregates
import Aggregates from '@/components/Pages/Aggregates/Aggregates'
import AggregatesIndex from '@/components/Pages/Aggregates/AggregatesIndex'
import AggregatesAppointments from '@/components/Pages/Aggregates/AggregatesAppointments'
import AggregatesAppointmentsMonth from '@/components/Pages/Aggregates/AggregatesAppointmentsMonth'
import AggregatesAppointmentsMonth2 from '@/components/Pages/Aggregates/AggregatesAppointmentsMonth2'
import AggregatesContracts from '@/components/Pages/Aggregates/AggregatesContracts'
import AggregatesAgreements from '@/components/Pages/Aggregates/AggregatesAgreements'
import AggregatesContractsMonth from '@/components/Pages/Aggregates/AggregatesContractsMonth'
import AggregatesPaymentdetails from '@/components/Pages/Aggregates/AggregatesPaymentdetails'
import AggregatesTutorChannels from '@/components/Pages/Aggregates/AggregatesTutorChannels'

// Contracts
import Contracts from '@/components/Pages/Contracts/Contracts'
import ContractsIndex from '@/components/Pages/Contracts/ContractsIndex'
import ContractsAdd from '@/components/Pages/Contracts/ContractsAdd'
// Contract
import Contract from '@/components/Pages/Contract/Contract'
import ContractIndex from '@/components/Pages/Contract/ContractIndex'

// Paymentdetails
import Paymentdetails from '@/components/Pages/Paymentdetails/Paymentdetails'
import PaymentdetailsIndex from '@/components/Pages/Paymentdetails/PaymentdetailsIndex'
import PaymentdetailsAdd from '@/components/Pages/Paymentdetails/PaymentdetailsAdd'
// Paymentdetail
import Paymentdetail from '@/components/Pages/Paymentdetail/Paymentdetail'
import PaymentdetailIndex from '@/components/Pages/Paymentdetail/PaymentdetailIndex'

// Paymentdetails2s
import Paymentdetails2s from '@/components/Pages/Paymentdetails2s/Paymentdetails2s'
import Paymentdetails2sIndex from '@/components/Pages/Paymentdetails2s/Paymentdetails2sIndex'
import Paymentdetails2sAdd from '@/components/Pages/Paymentdetails2s/Paymentdetails2sAdd'
// Paymentdetails2
import Paymentdetails2 from '@/components/Pages/Paymentdetails2/Paymentdetails2'
import Paymentdetails2Index from '@/components/Pages/Paymentdetails2/Paymentdetails2Index'

// Ledger
import ContractsIndexLedger from '@/components/Pages/Contracts/ContractsIndexLedger'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/states',
      component: States,
      name: 'states',
      children: [
        {
          path: '',
          component: StatesIndex,
          name: 'statesindex'
        }
      ]
    },
    {
      path: '/',
      component: Index,
      name: 'index'
    },
    {
      path: '/test',
      component: Index2,
      name: 'index2'
    },
    {
      path: '/test2',
      component: Index3,
      name: 'index3'
    },
    {
      path: '/mypage',
      component: Mypage,
      name: 'mypage'
    },
    {
      path: '/versions',
      component: Versions,
      // name: 'versions',
      children: [
        {
          path: '',
          component: VersionsIndex,
          name: 'versionsindex'
        }
      ]
    },
    {
      path: '/print',
      component: Print,
      name: 'print',
      children: [
        {
          path: 'ap',
          component: PrintAp,
          name: 'printap'
        }
      ]
    },
    {
      path: '/documents',
      component: Documents,
      // name: 'documents',
      children: [
        {
          path: '',
          components: {
            default: DocumentsIndex,
            a: Document
          },
          name: 'documentsindex'
        },
        {
          path: 'view/:id',
          components: {
            default: DocumentsIndex,
            a: Document
          },
          // name: 'document',
          children: [
            {
              path: '',
              component: DocumentIndex,
              name: 'documentindex'
            }
          ]
        }
      ]
    },
    {
      path: '/users',
      component: Users,
      // name: 'users',
      children: [
        {
          path: '',
          component: UsersIndex,
          name: 'usersindex'
        },
        {
          path: 'add',
          component: UsersAdd,
          name: 'usersadd'
        }
      ]
    },
    {
      path: '/user/view/:id',
      component: User,
      // name: 'user',
      children: [
        {
          path: '',
          component: UserIndex,
          name: 'userindex'
        },
        {
          path: 'img',
          component: UserImg,
          name: 'userimg'
        }
      ]
    },
    {
      path: '/advisors',
      component: Advisors,
      // name: 'advisors',
      children: [
        {
          path: '',
          component: AdvisorsIndex,
          name: 'advisorsindex'
        },
        {
          path: 'add',
          component: AdvisorsAdd,
          name: 'advisorsadd'
        }
      ]
    },
    {
      path: '/advisor/view/:id',
      component: Advisor,
      // name: 'advisor',
      children: [
        {
          path: '',
          component: AdvisorIndex,
          name: 'advisorindex'
        }
      ]
    },
    {
      path: '/channels',
      component: Channels,
      // name: 'channels',
      children: [
        {
          path: '',
          component: ChannelsIndex,
          name: 'channelsindex'
        }
      ]
    },
    {
      path: '/channel/view/:id',
      component: Channel,
      // name: 'channel',
      children: [
        {
          path: '',
          component: ChannelIndex,
          name: 'channelindex'
        }
      ]
    },
    {
      path: '/office_channels',
      component: Office_channels,
      // name: 'office_channels',
      children: [
        {
          path: '',
          component: Office_channelsIndex,
          name: 'office_channelsindex'
        }
      ]
    },
    {
      path: '/office_channel/view/:id',
      component: Office_channel,
      // name: 'office_channel',
      children: [
        {
          path: '',
          component: Office_channelIndex,
          name: 'office_channelindex'
        }
      ]
    },
    {
      path: '/appointment_channels',
      component: Appointment_channels,
      // name: 'appointment_channels',
      children: [
        {
          path: '',
          component: Appointment_channelsIndex,
          name: 'appointment_channelsindex'
        }
      ]
    },
    {
      path: '/appointment_channel/view/:id',
      component: Appointment_channel,
      // name: 'appointment_channel',
      children: [
        {
          path: '',
          component: Appointment_channelIndex,
          name: 'appointment_channelindex'
        }
      ]
    },
    {
      path: '/tutor_channels',
      component: Tutor_channels,
      // name: 'tutor_channels',
      children: [
        {
          path: '',
          component: Tutor_channelsIndex,
          name: 'tutor_channelsindex'
        }
      ]
    },
    {
      path: '/tutor_channel/view/:id',
      component: Tutor_channel,
      // name: 'tutor_channel',
      children: [
        {
          path: '',
          component: Tutor_channelIndex,
          name: 'tutor_channelindex'
        }
      ]
    },
    {
      path: '/appointments',
      component: Appointments,
      // name: 'appointments',
      children: [
        {
          path: '',
          component: AppointmentsIndex,
          name: 'appointmentsindex'
        },
        {
          path: 'add',
          component: AppointmentsAdd,
          name: 'appointmentsadd'
        },
        {
          path: 'modal',
          component: AppointmentsModal,
          name: 'appointmentsmodal'
        },
        {
          path: 'confirms',
          component: ConfirmsIndex,
          name: 'confirmsindex'
        },
        {
          path: 'calendar',
          component: AppointmentsCalendar,
          name: 'appointmentscalendar'
        }
      ]
    },

    {
      path: '/appointments2',
      component: Appointments2,
      children: [
        {
          path: '',
          components: {
            default: AppointmentsIndex2,
            a: Appointment2
          },
          name: 'appointmentsindex2'
        },
        {
          path: 'view/:id',
          components: {
            default: AppointmentsIndex2,
            a: Appointment2
          },
          children: [
            {
              path: '',
              component: AppointmentIndex2,
              name: 'appointmentindex2'
            },
            {
              path: 'map',
              component: AppointmentMap2,
              name: 'appointmentmap2'
            },
            {
              path: 'history',
              component: AppointmentHistory,
              name: 'appointmenthistory2'
            }
          ]
        }
      ]
    },

    {
      path: '/appointment/view/:id',
      component: Appointment,
      // name: 'appointment',
      children: [
        {
          path: '',
          component: AppointmentIndex,
          name: 'appointmentindex'
        },
        {
          path: 'map',
          component: AppointmentMap,
          name: 'appointmentmap'
        },
        {
          path: 'history',
          component: AppointmentHistory,
          name: 'appointmenthistory'
        }
      ]
    },
    {
      path: '/families',
      component: Families,
      // name: 'families',
      children: [
        {
          path: '',
          component: FamiliesIndex,
          name: 'familiesindex'
        },
        {
          path: 'add',
          component: FamiliesAdd,
          name: 'familiesadd'
        }
      ]
    },
    {
      path: '/family/view/:id',
      component: Family,
      // name: 'family',
      children: [
        {
          path: '',
          component: FamilyIndex,
          name: 'familyindex'
        },
        {
          path: 'map',
          component: FamilyMap,
          name: 'familymap'
        },
        {
          path: 'history',
          component: FamilyHistory,
          name: 'familyhistory'
        },
        {
          path: 'familyappointmentview',
          component: FamilyAppointmentView,
          name: 'familyappointmentview'
        },
        {
          path: 'familyfileview',
          component: FamilyfileView,
          name: 'familyfileview'
        },
        {
          path: 'familyagreements',
          component: FamilyAgreements,
          name: 'familyagreements'
        }
      ]
    },
    {
      path: '/students',
      component: Students,
      // name: 'students',
      children: [
        {
          path: '',
          component: StudentsIndex,
          name: 'studentsindex'
        },
        {
          path: 'add',
          component: StudentsAdd,
          name: 'studentsadd'
        },
        {
          path: 'inheritance',
          component: StudentsIndexInheritance,
          name: 'studentsindexinheritance'
        }
      ]
    },
    {
      path: '/student/view/:id',
      component: Student,
      // name: 'student',
      children: [
        {
          path: '',
          component: StudentIndex,
          name: 'studentindex'
        },
        {
          path: 'map',
          component: StudentMap,
          name: 'studentmap'
        },
        {
          path: 'history',
          component: StudentHistory,
          name: 'studenthistory'
        },
        {
          path: 'studentfileview',
          component: StudentfileView,
          name: 'studentfileview'
        },
        {
          path: 'studentreports',
          component: StudentReports,
          name: 'studentreports'
        },
        {
          path: 'studentagreements',
          component: StudentAgreements,
          name: 'studentagreements'
        }
      ]
    },
    {
      path: '/tutors',
      component: Tutors,
      // name: 'tutors',
      children: [
        {
          path: '',
          component: TutorsIndex,
          name: 'tutorsindex'
        },
        {
          path: 'add',
          component: TutorsAdd,
          name: 'tutorsadd'
        }
      ]
    },

    {
      path: '/tutors2',
      component: Tutors2,
      children: [
        {
          path: '',
          components: {
            default: TutorsIndex2,
            a: Tutor2
          },
          name: 'tutorsindex2'
        },
        {
          path: 'view/:id',
          components: {
            default: TutorsIndex2,
            a: Tutor2
          },
          children: [
            {
              path: '',
              component: TutorIndex2,
              name: 'tutorindex2'
            },
            {
              path: 'student',
              component: TutorStudent2,
              name: 'tutorstudent2'
            },
            {
              path: 'medium',
              component: TutorMedium2,
              name: 'tutormedium2'
            },
            {
              path: 'map',
              component: TutorMap2,
              name: 'tutormap2'
            },
            {
              path: 'history',
              component: TutorHistory2,
              name: 'tutorhistory2'
            },
            {
              path: 'tutorfileview',
              component: TutorfileView2,
              name: 'tutorfileview2'
            },
            {
              path: 'tutorreports',
              component: TutorReports,
              name: 'tutorreports2'
            },
            {
              path: 'tutoragreements',
              component: TutorAgreements,
              name: 'tutoragreements2'
            },
            {
              path: 'Img',
              component: TutorImg,
              name: 'tutorimg2'
            }
          ]
        }
      ]
    },

    {
      path: '/tutor/view/:id',
      component: Tutor,
      // name: 'tutor',
      children: [
        {
          path: '',
          component: TutorIndex,
          name: 'tutorindex'
        },
        {
          path: 'medium',
          component: TutorMedium,
          name: 'tutormedium'
        },
        {
          path: 'map',
          component: TutorMap,
          name: 'tutormap'
        },
        {
          path: 'history',
          component: TutorHistory,
          name: 'tutorhistory'
        },
        {
          path: 'tutorfileview',
          component: TutorfileView,
          name: 'tutorfileview'
        },
        {
          path: 'tutorreports',
          component: TutorReports,
          name: 'tutorreports'
        },
        {
          path: 'tutoragreements',
          component: TutorAgreements,
          name: 'tutoragreements'
        },
        {
          path: 'Img',
          component: TutorImg,
          name: 'tutorimg'
        }
      ]
    },
    {
      path: '/appointmentsupports',
      component: Appointmentsupports,
      // name: 'appointmentsupports',
      children: [
        {
          path: '',
          component: AppointmentsupportsIndex,
          name: 'appointmentsupportsindex'
        }
      ]
    },
    {
      path: '/familysupports',
      component: Familysupports,
      // name: 'familysupports',
      children: [
        {
          path: '',
          component: FamilysupportsIndex,
          name: 'familysupportsindex'
        }
      ]
    },
    {
      path: '/tutorsupports',
      component: Tutorsupports,
      // name: 'tutorsupports',
      children: [
        {
          path: '',
          component: TutorsupportsIndex,
          name: 'tutorsupportsindex'
        }
      ]
    },
    {
      path: '/familyfiles',
      component: Familyfiles,
      // name: 'familyfiles',
      children: [
        {
          path: '',
          component: FamilyfilesIndex,
          name: 'familyfilesindex'
        }
      ]
    },
    {
      path: '/familyfile/view/:id',
      component: Familyfile,
      // name: 'familyfile',
      children: [
        {
          path: '',
          component: FamilyfileIndex,
          name: 'familyfileindex'
        }
      ]
    },
    {
      path: '/studentfiles',
      component: Studentfiles,
      // name: 'studentfiles',
      children: [
        {
          path: '',
          component: StudentfilesIndex,
          name: 'studentfilesindex'
        }
      ]
    },
    {
      path: '/studentfile/view/:id',
      component: Studentfile,
      // name: 'studentfile',
      children: [
        {
          path: '',
          component: StudentfileIndex,
          name: 'studentfileindex'
        }
      ]
    },
    {
      path: '/tutorfiles',
      component: Tutorfiles,
      // name: 'tutorfiles',
      children: [
        {
          path: '',
          component: TutorfilesIndex,
          name: 'tutorfilesindex'
        }
      ]
    },
    {
      path: '/tutorfile/view/:id',
      component: Tutorfile,
      // name: 'tutorfile',
      children: [
        {
          path: '',
          component: TutorfileIndex,
          name: 'tutorfileindex'
        }
      ]
    },
    {
      path: '/reports',
      component: Reports,
      // name: 'reports',
      children: [
        {
          path: '',
          component: ReportsIndex,
          name: 'reportsindex'
        }
      ]
    },
    {
      path: '/report/view/:id',
      component: Report,
      // name: 'report',
      children: [
        {
          path: '',
          component: ReportIndex,
          name: 'reportindex'
        }
      ]
    },
    {
      path: '/student_tutors',
      component: Student_tutors,
      // name: 'student_tutors',
      children: [
        {
          path: '',
          component: Student_tutorsIndex,
          name: 'student_tutorsindex'
        }
      ]
    },
    {
      path: '/student_tutor/view/:id',
      component: Student_tutor,
      // name: 'student_tutor',
      children: [
        {
          path: '',
          component: Student_tutorIndex,
          name: 'student_tutorindex'
        }
      ]
    },
    {
      path: '/tags',
      component: Tags,
      // name: 'tags',
      children: [
        {
          path: '',
          component: TagsIndex,
          name: 'tagsindex'
        }
      ]
    },
    {
      path: '/tag/view/:id',
      component: Tag,
      // name: 'tag',
      children: [
        {
          path: '',
          component: TagIndex,
          name: 'tagindex'
        }
      ]
    },
    {
      path: '/conditions',
      component: Conditions,
      // name: 'conditions',
      children: [
        {
          path: '',
          component: ConditionsIndex,
          name: 'conditionsindex'
        }
      ]
    },
    {
      path: '/condition/view/:id',
      component: Condition,
      // name: 'condition',
      children: [
        {
          path: '',
          component: ConditionIndex,
          name: 'conditionindex'
        }
      ]
    },
    {
      path: '/student_conditions',
      component: Student_conditions,
      // name: 'student_conditions',
      children: [
        {
          path: '',
          component: Student_conditionsIndex,
          name: 'student_conditionsindex'
        }
      ]
    },
    {
      path: '/student_condition/view/:id',
      component: Student_condition,
      // name: 'student_condition',
      children: [
        {
          path: '',
          component: Student_conditionIndex,
          name: 'student_conditionindex'
        }
      ]
    },
    {
      path: '/tutor_conditions',
      component: Tutor_conditions,
      // name: 'tutor_conditions',
      children: [
        {
          path: '',
          component: Tutor_conditionsIndex,
          name: 'tutor_conditionsindex'
        }
      ]
    },
    {
      path: '/tutor_condition/view/:id',
      component: Tutor_condition,
      // name: 'tutor_condition',
      children: [
        {
          path: '',
          component: Tutor_conditionIndex,
          name: 'tutor_conditionindex'
        }
      ]
    },
    {
      path: '/todos',
      component: Todos,
      // name: 'todos',
      children: [
        {
          path: '',
          component: TodosIndex,
          name: 'todosindex'
        }
      ]
    },
    {
      path: '/todo/view/:id',
      component: Todo,
      // name: 'todo',
      children: [
        {
          path: '',
          component: TodoIndex,
          name: 'todoindex'
        }
      ]
    },
    {
      path: '/agreements',
      component: Agreements,
      // name: 'agreements',
      children: [
        {
          path: '',
          component: AgreementsIndex,
          name: 'agreementsindex'
        },
        {
          path: 'add',
          component: AgreementsAdd,
          name: 'agreementsadd'
        }
      ]
    },
    {
      path: '/agreement/view/:id',
      component: Agreement,
      // name: 'agreement',
      children: [
        {
          path: '',
          component: AgreementIndex,
          name: 'agreementindex'
        },
        {
          path: 'history',
          component: AgreementHistory,
          name: 'agreementhistory'
        },
        {
          path: 'diff',
          component: AgreementDiff,
          name: 'agreementdiff'
        },
        {
          path: 'pdf',
          component: AgreementPdf,
          name: 'agreementpdf'
        }
      ]
    },
    {
      path: '/aggregates',
      component: Aggregates,
      // name: 'aggregates',
      children: [
        {
          path: '',
          component: AggregatesIndex,
          name: 'aggregatesindex'
        },
        {
          path: 'appointments',
          component: AggregatesAppointments,
          name: 'aggregatesappointments'
        },
        {
          path: 'appointments_month',
          component: AggregatesAppointmentsMonth,
          name: 'aggregatesappointmentsmonth'
        },
        {
          path: 'appointments_month2',
          component: AggregatesAppointmentsMonth2,
          name: 'aggregatesappointmentsmonth2'
        },
        {
          path: 'contracts',
          component: AggregatesContracts,
          name: 'aggregatescontracts'
        },
        {
          path: 'agreements',
          component: AggregatesAgreements,
          name: 'aggregatesagreements'
        },
        {
          path: 'contracts_month',
          component: AggregatesContractsMonth,
          name: 'aggregatescontractsmonth'
        },
        {
          path: 'paymentdetails',
          component: AggregatesPaymentdetails,
          name: 'aggregatespaymentdetails'
        },
        {
          path: 'tutor_channels',
          component: AggregatesTutorChannels,
          name: 'aggregatestutorchannels'
        }
      ]
    },
    // Contracts
    {
      path: '/contracts',
      component: Contracts,
      // name: 'contracts',
      children: [
        {
          path: '',
          component: ContractsIndex,
          name: 'contractsindex'
        },
        {
          path: 'add',
          component: ContractsAdd,
          name: 'contractsadd'
        }
      ]
    },
    {
      path: '/contract/view/:id',
      component: Contract,
      // name: 'contract',
      children: [
        {
          path: '',
          component: ContractIndex,
          name: 'contractindex'
        }
      ]
    },
    // Paymentdetails
    {
      path: '/paymentdetails',
      component: Paymentdetails,
      // name: 'paymentdetails',
      children: [
        {
          path: '',
          component: PaymentdetailsIndex,
          name: 'paymentdetailsindex'
        },
        {
          path: 'add',
          component: PaymentdetailsAdd,
          name: 'paymentdetailsadd'
        }
      ]
    },
    {
      path: '/paymentdetail/view/:id',
      component: Paymentdetail,
      // name: 'paymentdetail',
      children: [
        {
          path: '',
          component: PaymentdetailIndex,
          name: 'paymentdetailindex'
        }
      ]
    },
    // Paymentdetails2s
    {
      path: '/paymentdetails2s',
      component: Paymentdetails2s,
      // name: 'paymentdetails2s',
      children: [
        {
          path: '',
          component: Paymentdetails2sIndex,
          name: 'paymentdetails2sindex'
        },
        {
          path: 'add',
          component: Paymentdetails2sAdd,
          name: 'paymentdetails2sadd'
        }
      ]
    },
    {
      path: '/paymentdetails2/view/:id',
      component: Paymentdetails2,
      // name: 'paymentdetails2',
      children: [
        {
          path: '',
          component: Paymentdetails2Index,
          name: 'paymentdetails2index'
        }
      ]
    },
    // Ledger
    {
      path: '/ledger-contracts',
      component: Contracts,
      // name: 'contracts',
      children: [
        {
          path: '',
          component: ContractsIndexLedger,
          name: 'contractsindexledger'
        }
      ]
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js